<template>
  <div class="form-page">
    <div class="form-page__header">
      <h2 class="form-page__title">Online-Ausweisfunktion (eID)</h2>
      <p class="form-page__subtitle">Identitätsprüfung über den Online-Ausweis</p>
    </div>

    <div class="form-section">
      <div class="info-block">
        <h3 class="info-block__title">Voraussetzungen für die Nutzung des Online-Ausweises:</h3>
        <ul class="info-block__list">
          <li>Personalausweis oder elektronischer Aufenthaltstitel mit aktivierter Online-Ausweisfunktion</li>
          <li>Persönliche Identifikationsnummer (PIN, 6-stellig)</li>
          <li>AusweisApp auf Ihrem Gerät installiert</li>
          <li>NFC-fähiges Smartphone oder USB-Kartenlesegerät</li>
        </ul>
      </div>

      <div class="info-box info-box--blue">
        <span class="info-box__icon">ℹ️</span>
        <div>
          <strong>Keine eID? Kein Problem.</strong>
          <p>Wenn Sie keinen Online-Ausweis nutzen möchten, können Sie den Antrag auch ohne eID stellen. Wählen Sie in diesem Fall „Nein".</p>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3 class="section-title">Möchten Sie Ihren Online-Ausweis nutzen? <span class="required-mark">*</span></h3>
      <div class="radio-group" :class="{ 'field--error': showErrors && modelValue.id_verwendung === null }">
        <label class="radio-label">
          <input
            type="radio"
            name="id_verwendung"
            :value="true"
            :checked="modelValue.id_verwendung === true"
            @change="update('id_verwendung', true)"
            class="radio-input"
          />
          <span class="radio-custom"></span>
          <span class="radio-text">Ja, ich möchte meinen Online-Ausweis nutzen</span>
        </label>
        <label class="radio-label">
          <input
            type="radio"
            name="id_verwendung"
            :value="false"
            :checked="modelValue.id_verwendung === false"
            @change="update('id_verwendung', false)"
            class="radio-input"
          />
          <span class="radio-custom"></span>
          <span class="radio-text">Nein, ich möchte ohne Online-Ausweis fortfahren</span>
        </label>
        <p v-if="showErrors && modelValue.id_verwendung === null" class="field__error">
          Bitte wählen Sie eine Option aus.
        </p>
      </div>

      <div v-if="modelValue.id_verwendung === true" class="info-box info-box--green" style="margin-top:16px">
        <span class="info-box__icon">✅</span>
        <div>
          <strong>Bereit zur eID-Authentifizierung</strong>
          <p>Im nächsten Schritt werden Sie zur Identitätsprüfung mit Ihrem Online-Ausweis weitergeleitet.</p>
        </div>
      </div>
    </div>

    <p class="required-note"><span class="required-mark">*</span> Pflichtfelder</p>
  </div>
</template>

<script>
export default {
  name: 'LitStep3',
  props: {
    modelValue: { type: Object, required: true },
    showErrors: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const update = (key, val) => emit('update:modelValue', { ...props.modelValue, [key]: val });
    return { update };
  },
};
</script>

<style scoped src="../form.css"></style>
